export abstract class GraphMathiaRoutes {
    static Attendance = 'attendance';
    static Progress = 'progress';
    static Level = 'level';
    static Errors = 'errors';
    static Statistics = 'statistics';
    static OwnProgress = 'own-progress';
}
